export default function Hipervinculo(params){
    const coleccion = params.coleccion;
    if(coleccion === "Areageograficas"){
        return(
            <div className="col-lg-9 col-xs-6 col-md-8 todo" id="Slp-nivel-2-1" style={{paddingLeft:"25px", paddingRight:"0px"}}>
                <div  id="Slp-nivel-2-1-1" style={{textAlign:"left", width:"90%"}}>
                    <div className="col-md-8 col-xs-12 col-sm-12 slp-tbl_buscador" id="todoroworden">
                        <div className="slp-tbl-row_buscador">
                            <div className="col-md-10 col-lg-11 slp-tbl-col_buscador" style={{display:"inline-flex"}}>
                                <div className="col-xs-12 col-md-8 col-lg-5" id="rutas" style={{paddingRight:"0px", paddingLeft:"0px"}}>
                                </div>
                                <div className="col-xs-12 col-md-1 col-lg-1" id="separadorId" style={{width:"5%", paddingRight:"0px", paddingLeft:"0px"}}>
                                </div>
                                <div className="col-xs-12 col-md-9 col-lg-5" id="rutas2" style={{paddingRight:"0px", paddingLeft:"0px"}}>
                                </div>
                            </div>
                        </div>    
                    </div>
                </div>
            </div>
        )
    }
    else{
        return(
        <div className="col-lg-9 col-xs-6 col-md-8 todo" id="Slp-nivel-2-1" style={{paddingLeft:"25px", paddingRight:"0px"}}>
            <div  id="Slp-nivel-2-1-1" style={{textAlign:"left", width:"90%"}}>
                <div className="col-md-8 col-xs-12 col-sm-12 slp-tbl_buscador" id="todoroworden">
                    <div className="slp-tbl-row_buscador">
                        <div className="col-md-10 col-lg-11 slp-tbl-col_buscador" style={{display:"inline-flex"}}>
                            <div className="col-xs-12 col-md-8 col-lg-12" id="rutas" style={{paddingRight:"0px", paddingLeft:"0px"}}>
                            </div>
                        </div>
                    </div>    
                </div>
            </div>
        </div>
    )
    }
}

